export default {
  /**
   * @returns []
   */
  getPushPrices(state) {
    return state.pushPrices.items.map((item) => {
      const errors = [];
      const warnings = [];
      let type = 'success';
      let label = 'OK';
      let status = {};
      // error checking
      if (item.rateAmount <= 0) {
        errors.push('rateAmount <b>MUST</b> be greater than 0');
      }
      if (item.minStay <= 0) {
        errors.push('minStay <b>MUST</b> be greater than 0');
      }
      if (item.maxStay <= 0) {
        errors.push('maxStay <b>MUST</b> be greater than 0');
      }
      if (item.maxStay < item.minStay) {
        errors.push('maxStay <b>MUST</b> be greater than or equal to minStay');
      }

      //  checking warnings
      if (item.masterStatus.toLowerCase() === 'closed') {
        warnings.push('MasterStatus is Closed(stay not possible)');
      }
      if (item.bookingLimit === 0) {
        warnings.push('bookingLimit is 0 (no availability)');
      }

      if (errors.length) {
        type = 'error';
        label = 'Error';
      } else if (warnings.length) {
        type = 'warning';
        label = 'Warning';
      }

      status = {
        type,
        label,
        warnings,
        errors,
      };
      return { ...item, status };
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/prices/getters.js